import { render } from "./CoachDetail.vue?vue&type=template&id=8cbc45c4"
import script from "./CoachDetail.vue?vue&type=script&lang=js"
export * from "./CoachDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\vue-js\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__